/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class AttributeManager
{
    private _colourBoxes: JQuery;
    private _attributeList: Array<any> = [];
    private _attributeData = {
        id: 0,
        slug: '',
        attributeId: 0,
        attributeSlug: '',
        selected: 0
    }

    /**
     * Attribute disabled in:
     * app\modules\basic\templates\product\attributes\attributes.html.twig
     * by add style.
     */
    constructor() {
        this.registerAttributes();
        this.showNotColourAttribute();
    }

    public registerAttributes(): void {
        const currentObject = this;
        $('.colour-attribute-row').each(function () {
            currentObject._attributeList.push({id: $(this).data('id'), slug: $(this).data('slug')});
        })
    }

    public changeColourAttributeValue(colourBox: JQuery): void {
        this.clearAttributeData();
        this.setAttributeData(colourBox);
        this._colourBoxes = $('.colour-box-' + this._attributeData.attributeId);
        this.changeColourAttributeValueStatus(colourBox);
        this.changeBaseAttribute();
    }

    public refreshColourAttributeValue(): void {
        setTimeout(() => {
            for(const [key, attribute] of Object.entries(this._attributeList)) {
                $('.list-' + attribute.slug).find('.colour-box').each(function () {
                    let accept = false;
                    const colourSlug = $(this).data('slug');
                    $('#' + attribute.slug).find('option').each(function () {
                        if(colourSlug == $(this).val()) {
                            accept = true;
                        }
                    })
                    if(accept) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                })
            }
        }, 10)
    }

    public resetAttribute(): void {
        this.clearAttributeData();
        $('.colour-box').removeClass('selected-colour');
    }

    private showNotColourAttribute(): void {
        const currentObject = this;
        $('.variations').find('tr').each(function () {
            const id = $(this).find('select').attr('id');
            for(const [key, attribute] of Object.entries(currentObject._attributeList)) {
                if(id != attribute.slug) {
                    $(this).css('position', 'relative');
                    $(this).css('left', '0px');
                }
            }
        })
    }

    private clearAttributeData(): void {
        this._attributeData.id = 0;
        this._attributeData.slug = '';
        this._attributeData.attributeId = 0;
        this._attributeData.attributeSlug = '';
        this._attributeData.selected = 0;
    }

    private setAttributeData(colourBox: JQuery): void {
        this._attributeData.id = colourBox.data('id') as number;
        this._attributeData.slug = colourBox.data('slug');
        this._attributeData.attributeId = colourBox.data('attribute') as number;
        this._attributeData.attributeSlug = colourBox.data('attributes-slug');
        this._attributeData.selected = colourBox.data('id') as number;
    }

    private changeColourAttributeValueStatus(colourBox: JQuery): void {
        if(colourBox.hasClass('selected-colour')) {
            this._attributeData.selected = 0;
            colourBox.removeClass('selected-colour');
        } else {
            this._colourBoxes.removeClass('selected-colour');
            colourBox.addClass('selected-colour');
        }
    }

    private changeBaseAttribute(): void {
        if(this._attributeData.selected !== 0) {
            $('#' + this._attributeData.attributeSlug + ' option[value="'+this._attributeData.slug+'"]').prop('selected', true);
        } else {
            $('#' + this._attributeData.attributeSlug + ' option:first').prop('selected', true);
        }
        $('#' + this._attributeData.attributeSlug).trigger('change');
    }
}